import React, { useEffect } from "react";
import { Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import StepsInfo from "../StepsInfo";
import Logo from "./img/complete.webp";

export default function CompleteStep() {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    document.title = "New Project";
  }, []);

  return (
    <div className="px-lg-3">
      <h1 className="fs-1 fw-bold">{t("projects.Add New Project")}</h1>
      <div className="text-gray mb-4 mb-md-5">
        <Link to={`${lng}/projects`}>{t("payment.Projects")}</Link>
        <span className="px-2">/</span>
        {t("projects.Add New Project")}
      </div>
      <div className="text-dark bg-white p-4 p-md-5 rounded">
        <StepsInfo
          step={3}
          stepNames={[
            t("projects.Project Name"),
            t("projects.Setup Domain"),
            t("projects.Complite Setup"),
          ]}
          className="mb-md-5 mx-auto col-lg-10 col-xl-8 col-xxl-7"
        />
        <Col md={8} lg={4} className="thirdStep mx-auto text-center mt-5">
          <img
            src={Logo}
            loading="lazy"
            alt="New Domain"
            className="img-fluid mb-4 my-md-4 pb-2"
          />
          <h3 className="mb-3 text-capitalize">
            {t("projects.Setup Complete")}
          </h3>
          <p className="text-gray mx-auto mb-5 mb-md-4 fs-7 pb-2">
            {t("projects.Your project setup is complete")}
          </p>
          <Col>
            <Link to={`${lng}/projects/${projectId}`}>
              <Button variant="primary" className="w-100 text-white">
                {t("projects.To Project")}
              </Button>
            </Link>
          </Col>
        </Col>
      </div>
    </div>
  );
}
